import { Box, Grid } from '@mui/material';
import { UserEntity } from 'app/interfaces/entity';
import { TournamentSettingsTitle } from 'modules/tournaments/components/TournamentSettingsTitle';
import { AdminCard } from 'modules/users/components/AdminCard';
import React, { FC } from 'react';

interface TournamentAdminsProps {
  owner?: UserEntity;
  admins: Partial<UserEntity>[];
}

export const TournamentAdmins: FC<TournamentAdminsProps> = ({ admins, owner }) => {
  return (
    <Box>
      <TournamentSettingsTitle>Admins</TournamentSettingsTitle>
      <Grid container spacing={2}>
        <Grid item xs={12} sm={6} md={6} lg={6} xl={3} key={owner?.id}>
          <AdminCard user={owner} isOwner />
        </Grid>
        {(admins ?? [])?.map((admin) => (
          <Grid item xs={12} sm={6} md={6} lg={6} xl={3} key={admin?.id}>
            <AdminCard user={admin} />
          </Grid>
        ))}
      </Grid>
    </Box>
  );
};
